import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import UpperCaseInput from '../../../components/UpperCaseInput';
import { Pencil } from 'lucide-react';

const EditDispatchModal = ({
  isOpen,
  onClose,
  selectedDispatch,
  formData,
  setFormData,
  importadoras,
  justification,
  setJustification,
  onSubmit
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Modificar Despacho - {selectedDispatch?.dispatch_number}</DialogTitle>
        </DialogHeader>
        <div className="bg-amber-50 border border-amber-200 rounded-md p-2 text-xs text-amber-800">
          <strong>Nota:</strong> Estás modificando datos del despacho. Se requiere justificación.
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Importadora *</Label>
              <Select value={formData.importadora_id} onValueChange={(v) => setFormData({ ...formData, importadora_id: v })}>
                <SelectTrigger><SelectValue placeholder="Seleccionar importadora" /></SelectTrigger>
                <SelectContent>
                  {importadoras.map(imp => (
                    <SelectItem key={imp.id} value={imp.id}>{imp.alias || imp.razon_social}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Número de Despacho *</Label>
              <UpperCaseInput 
                value={formData.dispatch_number} 
                onChange={(e) => setFormData({ ...formData, dispatch_number: e.target.value })} 
                required 
              />
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>N° CRT *</Label>
              <UpperCaseInput 
                value={formData.crt_number} 
                onChange={(e) => setFormData({ ...formData, crt_number: e.target.value })} 
                required 
              />
            </div>
            <div className="space-y-2">
              <Label>Cantidad de Camiones *</Label>
              <Input 
                type="number" 
                min="1" 
                value={formData.truck_count} 
                onChange={(e) => setFormData({ ...formData, truck_count: parseInt(e.target.value) || 1 })} 
                required 
              />
            </div>
          </div>
          
          <div className="bg-slate-50 border border-slate-200 rounded-md p-2 text-xs text-slate-600">
            <strong>Info:</strong> Los campos de Fecha Carga, Fecha Descarga, Corredor y Precio Flete se configuran a nivel de cada línea/camión.
          </div>
          
          <div className="space-y-2 pt-2 border-t">
            <Label className="text-red-600">Justificación *</Label>
            <UpperCaseInput 
              value={justification} 
              onChange={(e) => setJustification(e.target.value)} 
              required 
              placeholder="Motivo de la modificación" 
            />
          </div>
          
          <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white">
            <Pencil size={16} className="mr-2" /> Guardar Cambios
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditDispatchModal;
